module.exports = __webpack_public_path__ + "img/Dipres.42fbf25b.png";